// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__tzVRb","selected":"Chip_selected__230-8"};